import styled from 'styled-components';


export const buttonBackgroundColors = {
    'filled': '#832729',
    'outline': '#ffffff',
    'error': 'red',
    'disabled': 'rgba(89, 89, 89, 0.1)'
};
export const buttonTextColors = {
    'filled': '#ffffff',
    'outline': '#832729',
    'error': '#ffffff',
    'disabled': '#595959'
};

export const StyledButton = styled.button`
  width: ${(p) => p.width || '100%'};
  outline: none;
  letter-spacing: 0.2px;
  white-space: nowrap;
  padding: 8px 16px;
  font-weight: 500;
  border-radius: 13px;
  border: ${(p) => p.buttonType === 'outline' ? `1.5px solid #832729` : 'none'};
  cursor: ${(p) => p.buttonType === 'disabled' ? 'not-allowed' : 'pointer'};
  background-color: ${(p) => buttonBackgroundColors[p.buttonType]};
  color: ${(p) => buttonTextColors[p.buttonType]};
  font-size: 16px;
`;
